import { randomId, toSafeString } from '@shared/utils';
import { post } from '@/redux/requests/api.js';

export const respondApproval = ({ approvalId, approved, remember, threadId, runId, responseMode } = {}) => {
  const safeApprovalId = toSafeString(approvalId);
  const safeThreadId = toSafeString(threadId);
  const safeRunId = toSafeString(runId);
  const safeResponseMode = toSafeString(responseMode);
  const requestId = randomId();

  if (safeResponseMode === 'thread_run_control' && safeThreadId && safeRunId) {
    return post(`/v1/pieve/threads/${encodeURIComponent(safeThreadId)}/runs/${encodeURIComponent(safeRunId)}/approvals/${encodeURIComponent(safeApprovalId)}/respond`, {
      action: 'RESPOND_APPROVAL',
      meta: { approvalId: safeApprovalId, threadId: safeThreadId, runId: safeRunId, approved, remember, requestId },
      data: {
        decision: approved,
        remember,
        idempotencyKey: requestId,
        controlRequestId: requestId
      }
    });
  }

  return post(`/v1/pieve/approvals/${encodeURIComponent(safeApprovalId)}/respond`, {
    action: 'RESPOND_APPROVAL',
    meta: { approvalId: safeApprovalId, threadId: safeThreadId, approved, remember, requestId },
    data: { approved, remember }
  });
};
